<template>
  <a-card :title="$t(keyMessage[productSoldType])"
          style="margin:0 0 24px 20px;min-height: 488px"
          :bordered="false"
          :body-style="{ padding: 0 }">
    <div>
      <v-chart :forceFit="true" :height="height" :data="pieData" :scale="scale" :aadata="pieData">
        <v-tooltip :showTitle="false" dataKey="item*percent" />
        <v-axis />
        <v-legend dataKey="item" />
        <v-pie position="percent" color="item" :vStyle="pieStyle" :label="labelConfig" />
        <v-coord type="theta" :radius="0.75" :innerRadius="0.6" />
      </v-chart>
    </div>
  </a-card>
</template>

<script>
import request from '../../../utils/request'

const DataSet = require('@antv/data-set')

const keyMessage = {
  ITEM_SOLD: 'message.views.workbench.shopItemSoldData',
  ORDER_QUANTITY: 'message.views.workbench.shopOrderQuantityData'
}
const scale = [{
  dataKey: 'percent',
  min: 0,
  formatter: '.0%'
}]

export default {
  name: 'ShopProductSoldPieChartCard',
  computed: {
    pieData () {
      let sourceData = this.shopProductSoldData
      let dv = new DataSet.View().source(sourceData)
      dv.transform({
        type: 'percent',
        field: 'count',
        dimension: 'item',
        as: 'percent'
      })
      console.log('dv.rows:', dv.rows)
      return dv.rows
    }
  },
  props: {
    productSoldType: {
      type: String,
      default: 'ITEM_SOLD'
    }
  },
  data () {
    return {
      shopProductSoldData: [],
      keyMessage,
      pieStyle: {
        stroke: '#fff',
        lineWidth: 1
      },
      scale,
      height: 400,
      labelConfig: ['percent', {
        formatter: (val, item) => {
          return item.point.item + ': ' + val
        }
      }]
    }
  },
  mounted () {
    this.getShopProductSoldData()
  },
  methods: {
    getShopProductSoldData () {
      request({
        url: '/dashboard/shopProductSoldData',
        method: 'get',
        params: {
          productSoldDataType: this.productSoldType
        }
      }).then(response => {
        // response.data = json
        this.shopProductSoldData = response.data.model.map((item) => {
          return {
            item: item.key,
            count: parseInt(item.value)
          }
        })
        console.log('shopProductSoldData', this.shopProductSoldData)
        return response.data.model
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/ShopProductSoldPieChartCard.vue